const IA_PROPS = [
    'cardioRespiratory', 'musculoskeletal', 'musculoskeletalAmputees', 'musculoskeletalTMJ',
    'neurologicalParent', 'neurologicalVestibular', 'dermatofunctional', 'mentalHealth',
    'womensHealth', 'pelvicHealth', 'sportHealth', 'oncology', 'palliativeCare',
    'occupationalHealth', 'emergencyDisaster', 'animalHealth', 'publicHealth',
    'communityHealth', 'schoolHealth', 'pediatrics', 'gerontology', 'pain',
    'management', 'teaching', 'research', 'patientSafety', 'healthPromotion',
    'examAssessment', 'ptDiagnosis', 'educationalMeans', 'exercise', 'manualTherapies',
    'physicalTherapy', 'aquatic', 'electrophysiology', 'telePhysio', 'aiInterventions',
    'immobilizationDevices', 'clinicalRecord', 'intensiveCare', 'healthProtection', 'thermalism'
];

export const formatInterestAreasDataFormValues = (associate) => {
    if (associate.interestAreaData === null || associate.interestAreaData === undefined) {
        associate.interestAreaData = {};
        IA_PROPS.forEach(prop => { associate.interestAreaData[prop] = false; });
    }
    return associate;
};

export const formatInterestAreasDataToService = (associate) => {
    return associate;
};
